export const SET_SESSION_ID = "SET_SESSION_ID";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const SET_PUSH_ID = "SET_PUSH_ID";
export const SET_IS_CONNECTED = "SET_IS_CONNECTED";

// Lấy thông tin Config trên CMS
export const FETCH_CONFIG_REQUEST = "FETCH_CONFIG_REQUEST";
export const FETCH_CONFIG_SUCCESS = "FETCH_CONFIG_SUCCESS";
export const FETCH_CONFIG_FAILURE = "FETCH_CONFIG_FAILURE";
